<template>

<app-page :is-loading="true" />

</template>

<script>

import axios from 'axios'
import cookies from 'js-cookie'

export default {

    created: function() {

        cookies.remove(process.env.VUE_APP_COOKIE)

        axios.defaults.headers.common['Authorization'] = null

        this.$router.push({
            name: 'Home'
        })
    
    }

}

</script>

<style scoped>

</style>
